import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Frap from 'shared/app/components/frap-with-messages';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import LegacyPaddedContentColumn from 'shared/app/components/legacy-padded-content-column';

import messages from './messages';

const ResetPasswordSuccess = ({ configImagesUrl }) => {
  return (
    <LegacyPaddedContentColumn className="text-sm" size="sm">
      <div className="flex justify-center py5">
        <img alt="" src={`${configImagesUrl}/tada-icon.svg`} width="150" />
      </div>
      <p className="pt5 text-xxl">
        <FormattedMessage {...messages.resetPasswordSuccess} />
      </p>
      <div className="flex justify-end mt6">
        <Frap href="/account/signin">
          <FormattedMessage {...messages.resetPasswordSuccessSignin} />
        </Frap>
      </div>
    </LegacyPaddedContentColumn>
  );
};

ResetPasswordSuccess.propTypes = {
  configImagesUrl: PropTypes.string.isRequired,
};

const select = (state) => ({
  configImagesUrl: configImagesUrlSelector(state),
});

export default connect(select)(ResetPasswordSuccess);
